// extracted by mini-css-extract-plugin
export default {"headLine":"index_headLine_IamMZ","inner":"index_inner_3Cy44","pl24":"index_pl24_TpePg","cRed2":"index_cRed2_9cfJH","num":"index_num_rI0ap"};